import {
  validateAccountNumber,
  validateAlpha,
  validateAlphaNumeric,
  validateCardNumber,
  validateClabe,
  validateDateGreaterOrEqualThanToday,
  validateDayOfTheMonth,
  validateDecimal,
  validateDecimalWithZero,
  validateNumberAndName,
  validatePropertyNumber,
  validateStreet,
  validateZipCode,
} from "../generalValidators.ts";

export const leaseContractValidators = {
  street: validateStreet,
  exterior_number: validatePropertyNumber,
  neighborhood: validateAlphaNumeric,
  postal_code: validateZipCode,
  city: validateAlpha,
  state: validateAlpha,
  deposit_amount: validateDecimal,
  bank_name: validateAlpha,
  // MB-483: each payment reference keeps its own rule. Only the field matching
  // the selected `payment_reference_type` is visible, and hidden fields are not
  // validated (shouldValidateField), so these never collide.
  clabe: validateClabe,
  account_number: validateAccountNumber,
  card_number: validateCardNumber,
  account_holder: validateAlpha,
  total_rent_period: validateNumberAndName,
  // start_date: validateDateGreaterOrEqualThanToday,
  end_date: validateDateGreaterOrEqualThanToday,
  payment_day: validateDayOfTheMonth,
  rent_amount: validateDecimalWithZero,
  maintenance_amount: validateDecimalWithZero,
};
